/*
 * Ela Avaliações: interações da PDP.
 * O conteúdo inicial (resumo, fotos, 10 avaliações, perguntas) já vem no HTML,
 * renderizado pelo snippets/ela-rv-widget.liquid. Este script só age quando a
 * cliente clica: filtrar por nota/mídia, ordenar, ver mais e ampliar mídia.
 * Fonte das páginas seguintes: reviews-api (window.ElaReviews.api).
 */
(function () {
  'use strict';

  var API = (window.ElaReviews || {}).api;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function nl2br(s) { return esc(s).replace(/\n/g, '<br>'); }
  function fmtDate(iso) {
    var d = new Date(iso);
    return isNaN(d) ? '' : d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }
  function stars(n) {
    return '<span class="ela-rv-stars" style="--ela-rv-pct:' + Number(n) * 20 + '%" role="img" aria-label="Nota ' + n + ' de 5"></span>';
  }
  function thumb(m, nome) {
    var u = esc(m.url);
    return m.kind === 'video'
      ? '<button type="button" class="ela-rv__thumb ela-rv__thumb--video" data-ela-rv-open="' + u + '" data-kind="video" aria-label="Ver vídeo de ' +
        esc(nome) + '"><video src="' + u + '#t=0.5" preload="metadata" muted playsinline></video></button>'
      : '<button type="button" class="ela-rv__thumb" data-ela-rv-open="' + u + '" data-kind="photo" aria-label="Ampliar foto de ' +
        esc(nome) + '"><img src="' + u + '" alt="Foto enviada por ' + esc(nome) + '" loading="lazy" width="96" height="96"></button>';
  }
  function get(params) {
    var qs = Object.keys(params).filter(function (k) { return params[k] !== '' && params[k] != null; })
      .map(function (k) { return k + '=' + encodeURIComponent(params[k]); }).join('&');
    return fetch(API + '?' + qs).then(function (r) {
      if (!r.ok) throw new Error('reviews-api ' + r.status);
      return r.json();
    });
  }

  function reviewItem(r) {
    return '<li class="ela-rv__item"><div class="ela-rv__item-head">' + stars(r.rating) +
      '<span class="ela-rv__author">' + esc(r.customer_name) + '</span>' +
      (r.verified_buyer ? '<span class="ela-rv__verified">Compra verificada</span>' : '') +
      '<time class="ela-rv__date" datetime="' + esc(r.created_at) + '">' + fmtDate(r.created_at) + '</time></div>' +
      (r.body ? '<p class="ela-rv__body">' + nl2br(r.body) + '</p>' : '') +
      (r.media.length ? '<div class="ela-rv__thumbs">' + r.media.map(function (m) { return thumb(m, r.customer_name); }).join('') + '</div>' : '') +
      (r.reply_text ? '<div class="ela-rv__reply"><strong>Resposta da Ela Decora</strong><p>' + nl2br(r.reply_text) + '</p></div>' : '') +
      '</li>';
  }

  /* ---------- "Escrever avaliação" (review-submit) ---------- */
  var SUBMIT = API ? API.replace(/reviews-api\/?$/, 'review-submit') : '';
  var MAX_ARQUIVOS = 5;
  var MAX_VIDEO = 50 * 1024 * 1024;
  var MAX_FOTO = 25 * 1024 * 1024;
  var TIPOS = /^(image\/(jpeg|png|webp|heic)|video\/(mp4|quicktime))$/;

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    var b = crypto.getRandomValues(new Uint8Array(16));
    b[6] = (b[6] & 15) | 64; b[8] = (b[8] & 63) | 128;
    var h = Array.prototype.map.call(b, function (x) { return (x + 256).toString(16).slice(1); }).join('');
    return h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' + h.slice(16, 20) + '-' + h.slice(20);
  }
  function post(body) {
    return fetch(SUBMIT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) {
          if (!r.ok) throw new Error(d.error || 'Não foi possível enviar agora. Tente de novo.');
          return d;
        });
      });
  }
  /* foto do celular costuma ter 4–8 MB: reduz para 1600px em JPEG antes de subir */
  function reduzir(file) {
    if (!/^image\/(jpeg|png|webp)$/.test(file.type) || !window.createImageBitmap) return Promise.resolve(file);
    return createImageBitmap(file).then(function (bmp) {
      var s = Math.min(1, 1600 / Math.max(bmp.width, bmp.height));
      if (s === 1 && file.size < 1500000) return file;
      var c = document.createElement('canvas');
      c.width = Math.round(bmp.width * s); c.height = Math.round(bmp.height * s);
      var ctx = c.getContext('2d');
      ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, c.width, c.height);
      ctx.drawImage(bmp, 0, 0, c.width, c.height);
      return new Promise(function (res) {
        c.toBlob(function (b) { res(b ? new File([b], 'foto.jpg', { type: 'image/jpeg' }) : file); }, 'image/jpeg', 0.85);
      });
    }).catch(function () { return file; });
  }

  function initForm(root, pid) {
    var form = root.querySelector('[data-ela-rv-form]');
    var abrir = root.querySelector('[data-ela-rv-write]');
    if (!form || !abrir || !SUBMIT) { if (abrir) abrir.hidden = true; return; }
    var ok = root.querySelector('[data-ela-rv-ok]');
    var status = form.querySelector('[data-ela-rv-status]');
    var estrelas = form.querySelector('[data-ela-rv-estrelas]');
    var previas = form.querySelector('[data-ela-rv-previas]');
    var input = form.querySelector('[data-ela-rv-arquivos]');
    var enviar = form.querySelector('[data-ela-rv-enviar]');
    var sessao = uuid();
    var arquivos = [];
    var nota = 0;

    function pintar(n) {
      estrelas.querySelectorAll('label').forEach(function (l) {
        l.classList.toggle('is-on', Number(l.getAttribute('data-n')) <= n);
      });
    }
    function aviso(msg, erro) { status.textContent = msg || ''; status.classList.toggle('is-erro', !!erro); }
    function abrirForm(sim) {
      form.hidden = !sim;
      abrir.setAttribute('aria-expanded', sim ? 'true' : 'false');
      if (sim) { ok.hidden = true; form.scrollIntoView({ behavior: 'smooth', block: 'start' }); estrelas.querySelector('input').focus({ preventScroll: true }); }
    }

    abrir.addEventListener('click', function () { abrirForm(form.hidden); });
    form.querySelector('[data-ela-rv-cancelar]').addEventListener('click', function () { abrirForm(false); abrir.focus(); });

    estrelas.addEventListener('change', function (e) { nota = Number(e.target.value); pintar(nota); });
    estrelas.addEventListener('mouseover', function (e) { var l = e.target.closest('label'); if (l) pintar(Number(l.getAttribute('data-n'))); });
    estrelas.addEventListener('mouseleave', function () { pintar(nota); });

    function desenharPrevias() {
      previas.innerHTML = arquivos.map(function (a, i) {
        var u = URL.createObjectURL(a);
        return '<li>' + (/^video/.test(a.type) ? '<video src="' + u + '#t=0.5" muted playsinline preload="metadata"></video>' : '<img src="' + u + '" alt="">') +
          '<button type="button" data-remover="' + i + '" aria-label="Remover arquivo ' + (i + 1) + '">×</button></li>';
      }).join('');
      input.closest('label').hidden = arquivos.length >= MAX_ARQUIVOS;
    }
    input.addEventListener('change', function () {
      var recusados = 0;
      Array.prototype.forEach.call(input.files, function (f) {
        var tipoOk = TIPOS.test(f.type) || (!f.type && /\.heic$/i.test(f.name));
        var tamOk = f.size <= (/^video/.test(f.type) ? MAX_VIDEO : MAX_FOTO);
        if (tipoOk && tamOk && arquivos.length < MAX_ARQUIVOS) arquivos.push(f); else recusados++;
      });
      input.value = '';
      desenharPrevias();
      aviso(recusados ? 'Alguns arquivos ficaram de fora: até 5 arquivos, fotos JPG/PNG/HEIC ou vídeos MP4/MOV de até 50 MB.' : '', !!recusados);
    });
    previas.addEventListener('click', function (e) {
      var b = e.target.closest('[data-remover]');
      if (b) { arquivos.splice(Number(b.getAttribute('data-remover')), 1); desenharPrevias(); }
    });

    function subir(f) {
      return reduzir(f).then(function (arq) {
        var tipo = arq.type || 'image/heic';
        return post({ action: 'upload', product_id: pid, sessao: sessao, content_type: tipo }).then(function (d) {
          return fetch(d.upload_url, { method: 'PUT', headers: { 'Content-Type': tipo }, body: arq }).then(function (r) {
            if (!r.ok) throw new Error('Não foi possível enviar um dos arquivos. Tente de novo ou envie sem ele.');
            return d.path;
          });
        });
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var nome = form.nome.value.trim();
      var email = form.email.value.trim();
      if (!nota) return aviso('Escolha uma nota de 1 a 5 estrelas.', true);
      if (!nome) { form.nome.focus(); return aviso('Informe seu nome.', true); }
      if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email)) { form.email.focus(); return aviso('Confira seu e-mail.', true); }
      enviar.disabled = true;
      aviso(arquivos.length ? 'Enviando fotos e vídeos…' : 'Enviando…');
      var paths = [];
      arquivos.reduce(function (p, f) {
        return p.then(function () { return subir(f).then(function (path) { paths.push(path); }); });
      }, Promise.resolve()).then(function () {
        aviso('Enviando…');
        return post({
          action: 'enviar', product_id: pid, sessao: sessao, rating: nota, nome: nome, email: email,
          body: form.body.value, media: paths, site: form.site.value
        });
      }).then(function () {
        form.hidden = true; abrir.hidden = true; ok.hidden = false; ok.focus();
      }).catch(function (err) {
        aviso(err.message, true);
      }).then(function () { enviar.disabled = false; });
    });
  }

  function init(root) {
    var pid = root.getAttribute('data-product-id');
    var st = { page: 1, sort: 'recent', rating: '', media: '', qaPage: 1 };
    initForm(root, pid);
    var list = root.querySelector('[data-ela-rv-list]');
    var pager = root.querySelector('[data-ela-rv-pager]');

    function sync() {
      var media = root.querySelector('[data-ela-rv-media]');
      if (media) media.setAttribute('aria-pressed', st.media ? 'true' : 'false');
      var clear = root.querySelector('[data-ela-rv-clear]');
      if (clear) clear.hidden = !(st.rating || st.media);
      root.querySelectorAll('.ela-rv__bar').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-rating') === st.rating);
      });
    }

    function load(append) {
      if (!API || !list) return;
      root.classList.add('is-loading');
      get({ product_id: pid, page: st.page, sort: st.sort, rating: st.rating, media: st.media })
        .then(function (d) {
          var html = d.reviews.map(reviewItem).join('');
          if (append) list.insertAdjacentHTML('beforeend', html);
          else list.innerHTML = html || '<li class="ela-rv__empty">Nenhuma avaliação com esse filtro.</li>';
          pager.innerHTML = d.page < d.pages ? '<button type="button" class="ela-rv__more" data-ela-rv-more>Ver mais avaliações</button>' : '';
        })
        .catch(function () {})
        .then(function () { root.classList.remove('is-loading'); });
    }

    function setFilter(key, val) {
      st[key] = val;
      st.page = 1;
      sync();
      load(false);
    }

    root.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('.ela-rv__bar'))) {
        var n = t.getAttribute('data-rating');
        setFilter('rating', st.rating === n ? '' : n);
        if (list) list.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (e.target.closest('[data-ela-rv-media]')) {
        setFilter('media', st.media ? '' : '1');
      } else if (e.target.closest('[data-ela-rv-clear]')) {
        st.rating = ''; st.media = ''; setFilter('page', 1);
      } else if (e.target.closest('[data-ela-rv-more]')) {
        st.page += 1; load(true);
      } else if ((t = e.target.closest('[data-ela-rv-qa-more]'))) {
        loadQuestions(t);
      } else if ((t = e.target.closest('[data-ela-rv-open]'))) {
        openMedia(t);
      }
    });
    var sort = root.querySelector('[data-ela-rv-sort]');
    if (sort) sort.addEventListener('change', function () { setFilter('sort', sort.value); });

    function loadQuestions(btn) {
      if (!API) return;
      st.qaPage += 1;
      btn.disabled = true;
      get({ type: 'questions', product_id: pid, page: st.qaPage }).then(function (d) {
        root.querySelector('[data-ela-rv-qa-list]').insertAdjacentHTML('beforeend', d.questions.map(function (q) {
          return '<li class="ela-rv-qa__item"><p class="ela-rv-qa__q"><strong>P:</strong> ' + nl2br(q.body) +
            ' <span class="ela-rv__date">' + esc(q.customer_name) + ' · ' + fmtDate(q.created_at) + '</span></p>' +
            '<p class="ela-rv-qa__a"><strong>R:</strong> ' + nl2br(q.answer_text) + '</p></li>';
        }).join(''));
        if (d.page >= d.pages) btn.remove(); else btn.disabled = false;
      }).catch(function () { btn.disabled = false; });
    }
  }

  var dlg;
  function openMedia(t) {
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.className = 'ela-rv-lightbox';
      dlg.addEventListener('click', function (ev) { if (ev.target === dlg || ev.target.closest('[data-close]')) dlg.close(); });
      dlg.addEventListener('close', function () { dlg.innerHTML = ''; });
      document.body.appendChild(dlg);
    }
    var url = esc(t.getAttribute('data-ela-rv-open'));
    dlg.innerHTML = '<button type="button" class="ela-rv-lightbox__close" data-close aria-label="Fechar">×</button>' +
      (t.getAttribute('data-kind') === 'video'
        ? '<video src="' + url + '" controls autoplay playsinline></video>'
        : '<img src="' + url + '" alt="Foto enviada por cliente">');
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }

  function boot() {
    document.querySelectorAll('[data-ela-rv-widget]:not([data-ela-rv-ready])').forEach(function (el) {
      el.setAttribute('data-ela-rv-ready', '1');
      init(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
